<template>
  <div class="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-100">
    <NavigationBar />
    <main>
      <slot />
    </main>
  </div>
</template>

<script>
import NavigationBar from './NavigationBar.vue'

export default {
  name: 'Layout',
  components: {
    NavigationBar
  }
}
</script> 